import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isNumber, isString } from '@partners/utils';
import { IRangeValidationHandler, TValidatorError } from '../../model';

export function minLengthValidator(args: Partial<IRangeValidationHandler<number>>): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;
    const { min } = args;
    if (invalid) return null;

    if (!isString(value) || !isNumber(value?.length)) return null;
    const valueLength = value.toString().length;
    const isLowerThenMin = valueLength && valueLength < min;

    if (isLowerThenMin) {
      const vldResponse: TValidatorError = { minLength: value };
      return vldResponse;
    }

    return null;
  };
}
